import moment from 'moment';

import helpers from '../../helpers';
import { setEntry } from './api';

// ----------------------------------------------------------------------------
// PROMISES
// ----------------------------------------------------------------------------
/* */
export const asyncSetEntry = (client, { enter, golf, transaction }) => {
  const {
 tournament, events, entrants, comment = null,
} = enter;

  const date = (tournament && tournament.startDate) || (events[0] && events[0].startDate);

  return setEntry(client, {
    date,
    comment,
    golfId: golf.id,
    players: entrants.map((entrant) => helpers.object.filterByKeys(
        {
          ...entrant,
          tid: entrant.reference,
          events: entrant.events.filter((e) => e),
        },
        ['tid', 'email', 'gender', 'lastname', 'firstname', 'licenseNumber', 'tournament', 'events'],
      )),
    payments: [
      {
        mode: 0,
        currency: golf.currency || 'EUR',
        ...transaction,
      },
    ],
  });
};

// ----------------------------------------------------------------------------
// UTILS
// ----------------------------------------------------------------------------
/* */
export const getRegistrationStatus = (event) => {
  let status = 1;
  let statusText;

  const endAt = moment(event.endAt, 'YYYY-MM-DD').endOf('day');
  const startAt = moment(event.startAt, 'YYYY-MM-DD').startOf('day');

  if (endAt.isBefore()) {
    status = 0;
    statusText = 'Inscriptions closes';
  } else if (startAt.isAfter()) {
    status = 1;
    statusText = `Début des inscriptions le ${startAt.format('DD/MM/YYYY')}`;
  } else if (event.open) {
    status = 2;
    if (endAt.dayOfYear() === moment().dayOfYear()) {
      statusText = 'Dernier jour d\'inscription';
    } else {
      statusText = `Inscriptions ouvertes jusqu'au ${endAt.format('DD/MM/YYYY')}`;
    }
    if (!event.openOnline) {
      status = 3;
      statusText += ' (uniquement à l\'accueil)';
    }
  } else {
    status = 0;
    statusText = 'Inscriptions closes';
  }

  return { status, statusText };
};

/* */
export const isOpened = (tournament) => {
  const { status } = getRegistrationStatus(tournament);
  return status === 2;
};

/* */
export const getEntryStatus = (entries, tid) => {
  const defaultValue = { entry: null, owner: null, partners: [] };
  const entry = entries && entries.find((e) => e.tid === tid);
  if (!entry) return defaultValue;

  const { bookingId, owner } = entry;
  return entries.reduce((acc, e) => {
    if (e.bookingId === bookingId) {
      acc.entry = e;
    }
    if (e.bookingId === owner && e.bookingId !== bookingId) {
      acc.owner = e;
    }
    if (e.partners.includes(bookingId)) {
      acc.partners.push(e);
    }

    return acc;
  }, defaultValue);
};

/* */
export const getFilters = (events) => {
  const filters = [];
  const regex = /[[a-z0-9- ]*]/gi;
  events.forEach((e) => {
    const matches = e.name.match(regex);
    if (matches) {
      matches.forEach((m, i) => {
        if (typeof filters[i] !== 'object') {
          filters[i] = [];
        }
        const sanitized = m.replace(/(\[|\])/g, '').trim();
        if (!filters[i].includes(sanitized)) {
          filters[i].push(sanitized);
        }
      });
    }
  });

  return filters.filter((f) => f && f.length > 1);
};

/* */
export const sanitize = (name) => name.replace(/\](\s)*\[/g, ' - ').replace(/(\[|\])/g, '');
